

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./grade.css');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 等级配置页面
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var Grade = function (_Component) {
    _inherits(Grade, _Component);

    function Grade(props) {
        _classCallCheck(this, Grade);

        var _this = _possibleConstructorReturn(this, (Grade.__proto__ || Object.getPrototypeOf(Grade)).call(this, props));

        _this.state = {
            value: props.value
        };
        return _this;
    }

    _createClass(Grade, [{
        key: 'componentWillMout',
        value: function componentWillMout() {
            this.configColorAndImageArray = [];
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                value: nextProps.value
            });
        }
    }, {
        key: 'getIndexWithGrade',
        value: function getIndexWithGrade(grade) {
            if (grade < 1) {
                return 0;
            }

            var x = grade;

            var n = 0;

            if (x < 44) {
                //等级小于44的时候每个区间的『等级差值』是一个等差数列
                //利用等差数列求和公式和求根公式来计算当前等级所在区间对应到图片存放的地方的坐标；输出0123456.....
                n = (Math.sqrt(9 + 8 * x) - 3) / 2;
            } else {
                //等级大于等于44的时候每个区间的『等级』是一个等差数列
                //利用等差数列通项公式来计算当前等级所在区间对应到图片存放的地方的坐标；输出0123456.....
                n = (x - 34) / 10;
                //与44级之前的对接
                n += 7;
            }

            return Math.floor(n);
        }
    }, {
        key: 'render',
        value: function render() {
            var idx = this.getIndexWithGrade(this.state.value);
            var image = 'grade_' + idx;
            var color = this.props.colors[idx];
            var style = {
                backgroundColor: color
            };

            return _react2.default.createElement(
                'div',
                { className: 'ui-grade' },
                _react2.default.createElement('i', { className: image }),
                _react2.default.createElement(
                    'em',
                    { style: style },
                    this.state.value
                )
            );
        }
    }]);

    return Grade;
}(_react.Component);

Grade.defaultProps = {
    value: 0,
    colors: ['rgba(179,212,101,1)', //color0
    'rgba(255,97,142,1)', //color1
    'rgba(248,58,75,1)', //color2
    'rgba(235,97,0,1)', //color3
    'rgba(248,58,75,1)', //color4
    'rgba(255,72,182,1)', //color5
    'rgba(255,59,112,1)', //color6
    'rgba(248,58,75,1)', //color7
    'rgba(178,97,255,1)', //color8
    'rgba(200,75,231,1)', //color9
    'rgba(66,142,255,1)', //color10
    'rgba(75,73,230,1)', //color11
    'rgba(178,97,255,1)', //color12
    'rgba(147,43,227,1)', //color13
    'rgba(32,205,255,1)', //color14
    'rgba(47,128,255,1)', //color15
    'rgba(178,97,255,1)', //color16
    'rgba(255,210,0,1)', //color17
    'rgba(255,146,0,1)', //color18
    'rgba(229,2,1,1)', //color19
    'rgba(130,0,189,1)', //color20
    'rgba(248,9,68,1)', //color21
    'rgba(186,4,25,1)', //color22
    'rgba(200,75,231,1)', //color23
    'rgba(153,46,254,1)' //color24
    ]
};


module.exports = Grade;


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-up-ui/dist/Grade.js
// module id = 339
// module chunks = 0 1